var map = {
	"./cast.svg": 1387,
	"./cc-off.svg": 878,
	"./cc-on.svg": 527,
	"./close.svg": 911,
	"./embed.svg": 1388,
	"./facebook.svg": 528,
	"./fullscreen-off.svg": 880,
	"./fullscreen-on.svg": 879,
	"./fw-15.svg": 525,
	"./left.svg": 1389,
	"./link.svg": 530,
	"./live.svg": 871,
	"./pause-big.svg": 883,
	"./pause.svg": 874,
	"./play-big.svg": 882,
	"./play-resume.svg": 531,
	"./play-round.svg": 885,
	"./play-small.svg": 912,
	"./play.svg": 873,
	"./quality-100.svg": 886,
	"./replay.svg": 884,
	"./right.svg": 1390,
	"./rw-15.svg": 526,
	"./settings.svg": 881,
	"./sharing.svg": 405,
	"./speed.svg": 406,
	"./toggle-pause.svg": 1391,
	"./toggle-play.svg": 1392,
	"./twitter.svg": 529,
	"./volume-0.svg": 875,
	"./volume-100.svg": 877,
	"./volume-50.svg": 876
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1386;